export default [
  {
    path: window.pathApp + '/obter-dados-de-acesso',
    name: 'dados.acesso',
    component: () => import('@/components/DadosAcesso'),
    meta: {
      login: false,
      title: "Obter dados de acesso",
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/routes/dados_acesso.js